import { Dispatch, SetStateAction } from 'react';

import PricingHeader from 'partsOld/components/PricingHeader';
import PricingList from 'partsOld/components/PricingList';
import { ICompanyPart, IPricing } from 'partsOld/types';

import { TableWrapper } from './pricingTabStyle';

interface IProps {
  part: Partial<ICompanyPart>;
  selectedPrice: IPricing;
  setSelectedPrice: Dispatch<SetStateAction<IPricing>>;
  onRowClick: (row) => void;
}
const PricingTabView = ({ part, selectedPrice, setSelectedPrice, onRowClick }: IProps) => {
  return (
    <TableWrapper>
      <PricingHeader
        part={part}
        selectedPrice={selectedPrice}
        setSelectedPrice={setSelectedPrice}
      />
      <PricingList part={part} onRowClick={onRowClick} />
    </TableWrapper>
  );
};

export default PricingTabView;
